export const CHANGE_PASSWORD_API_REQUEST = 'CHANGE_PASSWORD_API_REQUEST';
export const CHANGE_PASSWORD_API_ERROR = 'CHANGE_PASSWORD_API_ERROR';
export const CHANGE_PASSWORD_API_SUCCESS = 'CHANGE_PASSWORD_API_SUCCESS';
export const RESET_CHANGE_PASSWORD_SUCCESS = 'RESET_CHANGE_PASSWORD_SUCCESS';
